module.exports = __webpack_public_path__ + "pic1.jpg?4b38fae1a332bbeb8225466d965fa029";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog/grid/pic1.jpg
// module id = 55
// module chunks = 13